export const FAQ_CATEGORIES = [
  {
    id: "general",
    title: "General Questions",
    faqs: [
      {
        q: "What does Click World Online do?",
        a: "We're a full-service digital marketing agency based in Mansa, Punjab — working across strategy, websites, SEO, Google and Meta advertising, social media, lead generation, branding and 360° virtual experiences. Established in 2017, we've served 800+ clients.",
      },
      {
        q: "Where is Click World Online located?",
        a: "Our office is at #832, Ward No. 08, Mansa, Punjab 151505. We work in person across our home region and remotely with businesses throughout Punjab and beyond.",
        link: { label: "See the areas we serve", to: "/locations" },
      },
      {
        q: "How do we start working together?",
        a: "Send an enquiry, call or WhatsApp us — we'll schedule a discovery conversation to understand your business before recommending anything. No pressure, no boilerplate proposals.",
        link: { label: "Contact our team", to: "/contact" },
      },
      {
        q: "Which industries do you work with?",
        a: "Retail, education, healthcare, hospitality, real estate, manufacturing, professional services and more. Our 360° tour portfolio alone spans dozens of industries and cities.",
      },
    ],
  },
  {
    id: "website-development",
    title: "Website Development & Design",
    faqs: [
      {
        q: "How much does a professional website cost?",
        a: "Every project is scoped individually — a focused business website usually costs far less than people expect, and we quote honestly without padding packages with things you don't need.",
        link: { label: "Our website design & development service", to: "/services/website-design-development" },
      },
      {
        q: "How long does it take to build a website?",
        a: "Most business websites launch within two to four weeks. The biggest variable is usually how quickly content, photos and approvals come from your side.",
      },
      {
        q: "Will my website work properly on mobile devices?",
        a: "Yes — every site we build is mobile-first, tested across screen sizes, and optimised to load fast even on modest connections and budget phones.",
      },
      {
        q: "Can I update my website after it is completed?",
        a: "Yes. We either hand over a site your team can edit easily, or look after updates for you through a simple monthly care plan.",
      },
      {
        q: "Do you provide domain and hosting assistance?",
        a: "Yes — we help you choose, register and configure your domain and hosting, and we keep everything in accounts that belong to you.",
      },
    ],
  },
  {
    id: "digital-marketing",
    title: "Digital Marketing",
    faqs: [
      {
        q: "Which marketing channels should my business use?",
        a: "It genuinely depends on your audience and goals — that's what the Discover stage answers. Most local businesses do best starting with Google and one social channel done properly.",
        link: { label: "Our digital marketing strategy service", to: "/services/digital-marketing-strategy" },
      },
      {
        q: "How soon will digital marketing show results?",
        a: "Paid campaigns and Google Business Profile work can produce enquiries within weeks. Organic channels like SEO and social presence compound over months. We set honest expectations before starting.",
      },
      {
        q: "Do you work with small marketing budgets?",
        a: "Yes — focused local campaigns can run on modest budgets. The discipline of choosing one or two right channels matters more than the size of the spend.",
      },
    ],
  },
  {
    id: "seo",
    title: "SEO",
    faqs: [
      {
        q: "How long does SEO usually take to show results?",
        a: "Typically three to six months for meaningful movement; local searches in smaller cities often improve sooner. SEO compounds — the work you do this quarter pays off next year.",
        link: { label: "Our SEO & search visibility service", to: "/services/seo" },
      },
      {
        q: "What is included in your SEO services?",
        a: "Keyword and intent research, on-page optimisation, technical fixes, content guidance, local SEO and Google Business Profile work — plus plain-language monthly reporting.",
      },
      {
        q: "Do you guarantee first position rankings on Google?",
        a: "No — and you should be cautious of anyone who does. Rankings depend on competition and Google's algorithm. What we guarantee is disciplined, transparent work you can verify.",
      },
      {
        q: "How do you choose the right keywords?",
        a: "We research the real language your customers type, classify it by intent, check difficulty, and prioritise terms you can realistically win — starting with local and high-intent searches.",
      },
    ],
  },
  {
    id: "local-seo",
    title: "Local SEO",
    faqs: [
      {
        q: "What is local SEO?",
        a: "Local SEO is the work that wins 'near me' and city searches — your Google Business Profile, reviews, local keywords, citations and location content working as one system.",
        link: { label: "Our local SEO service", to: "/services/local-seo" },
      },
      {
        q: "Do I need local SEO if I already have a website?",
        a: "Usually yes — a website alone doesn't put you in the map results where most local searches end. Local SEO connects your site, profile and reviews so they reinforce each other.",
      },
      {
        q: "Which areas do you provide local SEO for?",
        a: "We're based in Mansa and serve Bathinda, Chandigarh, Mohali and businesses across Punjab — including multi-location brands needing city-wise visibility.",
        link: { label: "Areas we serve", to: "/locations" },
      },
    ],
  },
  {
    id: "google-business-profile",
    title: "Google Business Profile",
    faqs: [
      {
        q: "What is Google Business Profile optimization?",
        a: "It's the process of completing and actively managing every part of your profile — categories, services, photos, posts, Q&A and reviews — so Google trusts it enough to show it prominently.",
        link: { label: "Our Google Business Profile service", to: "/services/google-business-profile" },
      },
      {
        q: "Why is Google Business Profile important for local businesses?",
        a: "For most local searches, the map results appear before websites. Your profile is often your first impression — it drives calls, direction requests and walk-ins directly.",
      },
      {
        q: "Can you help optimize an existing Google Business Profile?",
        a: "Yes — we audit what's there, fix categories and information, build a photo and posting rhythm, and set up an ethical flow for genuine customer reviews.",
      },
      {
        q: "How can Google Business Profile help attract more local customers?",
        a: "A complete, active, well-reviewed profile ranks higher in local results and converts better — customers see photos, reviews and clear contact options before they ever visit your website. Our own Mansa profile holds a 4.7-star rating.",
      },
    ],
  },
  {
    id: "lead-generation",
    title: "Lead Generation",
    faqs: [
      {
        q: "What counts as a lead?",
        a: "A genuine enquiry your team can act on — a call, WhatsApp message or form submission from a real potential customer. Not clicks, not impressions.",
        link: { label: "Our lead generation service", to: "/services/lead-generation" },
      },
      {
        q: "How do you keep lead quality high?",
        a: "Precise audience targeting, landing journeys that filter casually-interested clicks, and continuous review of which campaigns produce conversations rather than junk.",
      },
      {
        q: "Which channels do you use for lead generation?",
        a: "Mostly Google Ads, Meta advertising and conversion-focused landing pages — chosen based on where your customers actually are.",
      },
    ],
  },
  {
    id: "virtual-tours",
    title: "360° Virtual Tours & Google Street View",
    faqs: [
      {
        q: "What is a 360° virtual tour?",
        a: "An interactive, explorable view of your space — customers can look around your hotel, restaurant, clinic, institute or showroom from their phone, as if they were standing inside.",
        link: { label: "Explore our 360° experiences", to: "/360-experiences" },
      },
      {
        q: "Where will my virtual tour appear?",
        a: "On Google Maps and Street View through your business profile, and embedded on your own website — we've published 400+ such tours.",
        link: { label: "Google Street View publishing", to: "/services/google-street-view" },
      },
      {
        q: "How long does a 360° shoot take?",
        a: "Typically a few hours on-site, depending on the size of the space. We schedule around your business hours to avoid disruption.",
      },
      {
        q: "Which businesses benefit most from virtual tours?",
        a: "Any business where the space helps sell — hotels, restaurants, real estate, educational institutions, clinics, offices and retail showrooms.",
      },
    ],
  },
  {
    id: "pricing-process",
    title: "Pricing & Process",
    faqs: [
      {
        q: "How does your pricing work?",
        a: "Every engagement is scoped to what you actually need — a one-time project or a monthly plan. You'll always know what you're paying for and why, before anything starts.",
      },
      {
        q: "What does your working process look like?",
        a: "Four stages: Discover (understand your business), Strategize (build the plan), Create (develop the work), Launch & Optimize (release, monitor, improve). You're updated at every stage.",
      },
      {
        q: "Do you require long-term contracts?",
        a: "No lengthy lock-ins. Projects have clear scopes, and monthly engagements run with straightforward terms — we'd rather keep clients with results than paperwork.",
      },
    ],
  },
  {
    id: "support",
    title: "Support & Maintenance",
    faqs: [
      {
        q: "Do you provide website maintenance and support?",
        a: "Yes — care plans covering updates, content changes, backups and small improvements, so your site stays fast, secure and current.",
      },
      {
        q: "How do we reach you when we need help?",
        a: "Phone, WhatsApp or email — you talk directly to the team doing the work, not a ticket queue. Mansa clients can also drop by the office.",
      },
      {
        q: "What happens if something breaks on our website?",
        a: "Tell us and we fix it. Clients on care plans get priority support; even without one, we don't leave a client's site broken.",
      },
    ],
  },
];

export const SERVICE_FAQS = {
  "digital-marketing-strategy": [
    { q: "What does a strategy engagement include?", a: "Discovery of your business and market, channel selection, budget planning, a 90-day roadmap and a measurement framework — a document your whole marketing can run on." },
    { q: "We already run ads — is a strategy still useful?", a: "Often more useful. Most struggling ad accounts suffer from missing strategy, not missing spend. A strategy audit typically finds quick wins." },
    { q: "How is success measured?", a: "Against the goals set in discovery — enquiries, visibility, sales conversations — reviewed in plain-language monthly reporting." },
  ],
  seo: [
    { q: "How long does SEO usually take to show results?", a: "Typically three to six months for meaningful movement; local searches often improve sooner. The work compounds over time." },
    { q: "What is included in your SEO services?", a: "Keyword research, on-page and technical optimisation, content guidance, local SEO and Google Business Profile work, with monthly reporting." },
    { q: "Do you guarantee first position rankings on Google?", a: "No honest agency can guarantee a specific position. We guarantee disciplined, transparent work and reporting you can verify." },
    { q: "How do you choose the right keywords?", a: "From real customer search language — mapped by intent and difficulty, prioritising terms you can realistically win first.", link: { label: "Our keyword research service", to: "/services/keyword-research" } },
  ],
  "google-ads": [
    { q: "What budget do I need for Google Ads?", a: "It depends on your industry's click costs — local service searches can start modestly. We model a realistic budget before you commit anything." },
    { q: "How quickly can Google Ads bring enquiries?", a: "Campaigns can start generating enquiries within days of launch, then improve as we optimise targeting, ads and landing experience." },
    { q: "Do you manage the campaigns continuously?", a: "Yes — search term reviews, bid and audience adjustments, ad testing and landing page feedback are ongoing, not set-and-forget." },
  ],
  "meta-advertising": [
    { q: "Which platforms does Meta advertising cover?", a: "Facebook and Instagram — feed, stories and reels placements, managed from one campaign structure." },
    { q: "Do you create the ad designs and copy?", a: "Yes — creative direction, design and copy are handled in-house so ads look like your brand, not a template." },
    { q: "What's a realistic starting budget on Meta?", a: "For local businesses, Meta can start smaller than most channels. We'll recommend a test budget based on your audience size and goals." },
  ],
  "social-media-marketing": [
    { q: "How many posts will we get each month?", a: "Calendars are planned monthly around your goals — consistency and quality matter more than raw count. Exact volume is agreed in your plan." },
    { q: "Do you create the content or do we supply it?", a: "We create it — graphics, captions, photo and video content. Your input is approvals and the occasional on-site shoot." },
    { q: "Which social platforms should our business be on?", a: "For most local businesses: Instagram and Facebook, plus WhatsApp as a conversion channel. We confirm after understanding your audience." },
  ],
  "lead-generation": [
    { q: "What counts as a lead in your campaigns?", a: "A real enquiry — a call, WhatsApp message or form submission from someone genuinely interested. Never a click or impression." },
    { q: "How do you ensure lead quality?", a: "Through precise targeting, qualifying landing journeys, and continuous review of which campaigns produce actual conversations." },
    { q: "Can leads come straight to WhatsApp?", a: "Yes — WhatsApp-first journeys are one of the most effective setups for local businesses, and we build them regularly." },
  ],
  "content-creation": [
    { q: "What types of content do you produce?", a: "Graphics, photography, short-form video, copywriting and platform-ready formats for social, ads and websites." },
    { q: "Do you shoot content at our location?", a: "Yes — on-site photo and video shoots are part of the service, including 360° capture where it adds value." },
    { q: "Who owns the content you create for us?", a: "You do. Everything produced for your business is yours to use anywhere, forever." },
  ],
  "email-marketing": [
    { q: "We don't have an email list — can we still start?", a: "Yes — we help you build a genuine, permission-based list from your existing customers and enquiries. We never buy lists." },
    { q: "How often should a business send emails?", a: "Consistency beats frequency — for most businesses, a valuable monthly email outperforms four forgettable ones." },
    { q: "Which email tools do you work with?", a: "We're tool-agnostic and recommend based on your list size and budget — from simple platforms to full automation setups." },
  ],
  "keyword-research": [
    { q: "Is keyword research a one-time exercise?", a: "The foundation is built once; then it's refreshed as markets, seasons and search behaviour change — typically quarterly." },
    { q: "What will I receive from keyword research?", a: "A prioritised map of real search terms with intent, volume and difficulty — organised so your SEO and ads both know what to target." },
    { q: "Does keyword research help paid advertising too?", a: "Directly — the same research feeds Google Ads targeting, so organic and paid stop guessing separately." },
  ],
  "website-design-development": [
    { q: "How much does a professional website cost?", a: "Each project is scoped individually — focused business sites cost less than most fear. Share your requirement and we'll quote honestly." },
    { q: "How long does it take to build a website?", a: "Typically two to four weeks, depending mainly on content readiness and approval speed." },
    { q: "Will my website work properly on mobile devices?", a: "Yes — mobile-first is our default build standard, tested across devices and connection speeds." },
    { q: "Can I update my website after it is completed?", a: "Yes — either we hand over an editable site, or our care plan handles updates for you." },
    { q: "Do you provide domain and hosting assistance?", a: "Yes — selection, registration and configuration, all held in accounts owned by you." },
    { q: "Do you provide website maintenance and support?", a: "Yes — monthly care plans cover updates, backups, small changes and priority support.", link: { label: "Ask about care plans", to: "/contact" } },
  ],
  "branding-creative": [
    { q: "What's included in a branding project?", a: "Depending on scope: logo, colour and type systems, brand guidelines, social media kits and marketing collateral." },
    { q: "Can we get just a logo, or do we need a full identity?", a: "Both are possible — though even a logo project includes the core colour and usage guidance you'll need to stay consistent." },
    { q: "Do we receive the source files?", a: "Yes — final handover includes editable source files and ready-to-use exports for print and digital." },
  ],
  "360-virtual-tours": [
    { q: "What is a 360° virtual tour?", a: "An interactive walkthrough of your space that customers can explore from any device — like being there, before being there.", link: { label: "See 400+ published tours", to: "/360-experiences" } },
    { q: "Where does the tour appear?", a: "On Google Maps and Street View via your business profile, and embedded directly on your website." },
    { q: "How long does a 360° shoot take?", a: "Usually a few hours on-site, scheduled around your business hours." },
  ],
  "local-seo": [
    { q: "How is local SEO different from regular SEO?", a: "Local SEO targets map results and 'near me' searches — powered by your Google profile, reviews and location signals rather than website content alone." },
    { q: "What's included in a local SEO plan?", a: "Google Business Profile management, local keyword targeting, citation cleanup, review strategy and monthly visibility reporting." },
    { q: "How long until local SEO shows results?", a: "Local markets are less crowded than metros — meaningful movement often appears within two to four months of consistent work." },
  ],
  "google-business-profile": [
    { q: "What is Google Business Profile optimization?", a: "Completing and actively managing every profile element — categories, services, photos, posts, Q&A, reviews — so Google trusts and shows it prominently." },
    { q: "Why is Google Business Profile important for local businesses?", a: "Map results appear before websites in local searches. Your profile drives calls, direction requests and walk-ins directly." },
    { q: "Can you optimize an existing Google Business Profile?", a: "Yes — we audit, correct and then manage it: photos, posts, services and a genuine review flow." },
    { q: "How does it attract more local customers?", a: "A complete, active, well-reviewed profile ranks higher and converts better — customers see proof and contact options before visiting your site." },
  ],
  "google-street-view": [
    { q: "Is this official Google Street View?", a: "Yes — imagery is captured professionally and published through Google's own Street View systems, attached to your business listing." },
    { q: "Where will my Street View imagery show?", a: "On Google Maps, in search results on your business profile, and anywhere you embed it — including your own website." },
    { q: "How long does publishing take?", a: "The shoot takes a few hours; processing and publishing to Maps typically completes within days." },
  ],
};
